module.exports = __webpack_public_path__ + "static/img/A22.daf31069.jpg";